/* eslint-disable react/prop-types */
import React, {Component} from 'react';

import {isArray} from 'lodash';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Get, Post, Put, PutRequest} from '@/api/request';
import LoadCellBuffer from '@/assets/images/loadCell/LoadCellBuffer.svg';
import LoadCellSample from '@/assets/images/loadCell/LoadCellSample.png';
import LoadCellTubeCheck from '@/assets/images/loadCell/LoadCellTubeCheck.png';
import LoadCellTubeCross from '@/assets/images/loadCell/LoadCellTubeCross.png';
import Wizard from '@/components/wizard/Wizard';
import {TARE_STAGE_ENUM} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import {CalibrationScaleEvent} from '@/constants/pubSubEnum';
import {consoleLog} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import {STEP_WIZARD, POOLING_PARAM_LABEL, VOLUME_SENSOR_LABEL} from '../../../constants/calibrationWizardConstant';
// eslint-disable-next-line import/no-cycle
import PoolingSamplingData from '../containers/PoolingCapacitancesData';

import ShowResult from './Result';

import '../CalibrationLoadCellSensor.less';

const CalibrateParam = {
  ReferenceWeight: 'ReferenceWeight',
  SamplingNumber: 'SamplingNumber',
};

const FieldLabel = {
  NoTubeCalibration: [
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
  ],
  SampleTubeCalibration: [
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
  ],
  BufferTubeCalibration: [
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
  ],
  ResultCalibration: [
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
    APPDATA.FIELD_NAME.CALIBRATION_WEIGHT,
    APPDATA.FIELD_NAME.SENSOR_MEASUREMENT_WEIGHT,
  ],
};

const ViewNoTubePoolingParam = {
  [POOLING_PARAM_LABEL.IMAGES]: [LoadCellTubeCheck, LoadCellTubeCross],
  [POOLING_PARAM_LABEL.TEXT]: [
    APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.NO_TUBE_TEXT,
    APPDATA.FIELD_NAME.MEASURES,
    APPDATA.FIELD_NAME.TARE.toUpperCase(),
  ],
  [POOLING_PARAM_LABEL.FIELD_LABEL]: FieldLabel.NoTubeCalibration,
};

const ViewSampleTubePoolingParam = {
  [POOLING_PARAM_LABEL.IMAGES]: [LoadCellSample],
  [POOLING_PARAM_LABEL.TEXT]: [
    APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SAMPLE_TUBE_TEXT,
    APPDATA.FIELD_NAME.MEASURES,
    APPDATA.FIELD_NAME.CALIBRATE.toUpperCase(),
  ],
  [POOLING_PARAM_LABEL.FIELD_LABEL]: FieldLabel.SampleTubeCalibration,
};

const ViewBufferTubePoolingParam = {
  [POOLING_PARAM_LABEL.IMAGES]: [LoadCellBuffer],
  [POOLING_PARAM_LABEL.TEXT]: [
    APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.BUFFER_TUBE_TEXT,
    APPDATA.FIELD_NAME.MEASURES,
    APPDATA.FIELD_NAME.CALIBRATE.toUpperCase(),
  ],
  [POOLING_PARAM_LABEL.FIELD_LABEL]: FieldLabel.BufferTubeCalibration,
};

const ViewFinishReferencePoolingParam = {
  [POOLING_PARAM_LABEL.IMAGES]: [],
  [POOLING_PARAM_LABEL.TEXT]: [
    APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_FINISH_TEXT,
    APPDATA.FIELD_NAME.MEASURES,
    APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SAMPLE_SCALE,
    APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.BUFFER_SCALE,
  ],
  [POOLING_PARAM_LABEL.FIELD_LABEL]: FieldLabel.ResultCalibration,
};

const CalibrationResultId = {
  Protein: {
    Sensor: 'protein-sensor',
    Reference: 'protein-reference',
  },
  Buffer: {
    Sensor: 'buffer-sensor',
    Reference: 'buffer-reference',
  },
};

const WizardView = {
  wizardStep: 'WizardStep',
  resultChart: 'ResultChart',
  retakeView: 'RetakeView',
};

const backToHomePage = () => {
  window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
};

const backToCalibrationPage = () => {
  window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_ADDRESS;
};

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  isPCRunning: store.setupStore.isPCRunning,
  isRecalibration: store.setupStore.isRecalibration,
}))
class CalibrationLoadCellSensorWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calibrationTubeVolume: {
        [APPDATA.KEY.BufferSensor]: '-1',
        [APPDATA.KEY.BufferReference]: '-1',
        [APPDATA.KEY.ProteinSensor]: '-1',
        [APPDATA.KEY.ProteinReference]: '-1',
      },
      showCalibrationView: WizardView.wizardStep,
    };

    this._bus = eventBusObject();
    this.subscriptionDirection = this._bus.subscribe(CalibrationScaleEvent.SET_TOP_MENU, (param) =>
      this.TopMenuEvent(param),
    );

    this._isTareDonePooling = undefined;
    this._isCalibrateSampleDonePooling = undefined;
    this._isCalibrateBufferDonePooling = undefined;

    this.successSubmitCalibration = this.successSubmitCalibration.bind(this);
    this.successGetisTareDone = this.successGetisTareDone.bind(this);
    this.setLoadCellVolumeSensor = this.setLoadCellVolumeSensor.bind(this);
    this.successGetIsCalibrateDone = this.successGetIsCalibrateDone.bind(this);
    this.successCalibrateLoadCell = this.successCalibrateLoadCell.bind(this);
    this.successTareLoadCell = this.successTareLoadCell.bind(this);
  }

  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(setupActions.updateActiveMenu(APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE));
  }

  componentWillUnmount() {
    this.subscriptionDirection.unsubscribe();
  }

  ExitWizard = () => {
    const {dispatch} = this.props;

    const popUpButton = [
      {
        id: APPDATA.CONTINUE,
        isPrimaryButton: true,
        onClick: this.onClickPopUpBackButton,
        label: APPDATA.CONTINUE,
        disabled: false,
      },
      {
        id: APPDATA.EXIT,
        isPrimaryButton: false,
        onClick: this.onClickPopUpBackButton,
        label: APPDATA.EXIT,
      },
    ];

    dispatch(
      modalActions.showPopUp({
        popUpTitle: 'Exit Calibration Wizard',
        popUpText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.EXIT_PAGE,
        popUpButton,
      }),
    );
  };

  onClickPopUpBackButton = (e) => {
    const {dispatch} = this.props;

    dispatch(modalActions.hidePopUp());

    switch (e.currentTarget.id) {
      case APPDATA.EXIT:
        Put(APPDATA.API.CANCEL_CALIBRATION, {}, () => consoleLog('successCalibrateLoadCell'), {});
        backToCalibrationPage();
        break;
      case APPDATA.YES:
        backToCalibrationPage();
        break;
      case APPDATA.NO:
        break;
      case APPDATA.CONTINUE:
        break;
      default:
        break;
    }
  };

  nextOnClick = () => {
    this._bus.publish(Wizard.PubsubEvent.DIRECTION, Wizard.Direction.Next);
  };

  nextActionCallbackWizard = (step) => {
    const {calibrationTubeVolume} = this.state;

    const totalStep = this.wizardSteps().length;

    const param = {
      EnableButton: 'ENABLE',
      currentStep: step,
    };

    if (step < totalStep - 1) {
      if (step === 2) {
        if (calibrationTubeVolume[APPDATA.KEY.ProteinReference] === -1) {
          param.EnableButton = '';
          this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);
        } else this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);
      } else this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);
    } else if (step === totalStep - 1) {
      this.setTopMenuSaveResult(false);
    }

    this.forceUpdate();
  };

  backActionCallbackWizard = (step) => {
    const {calibrationTubeVolume} = this.state;

    const param = {
      EnableButton: 'ENABLE',
      currentStep: step + 1,
    };

    if (step < 0) {
      this.ExitWizard();
    } else if (step === 1) {
      if (calibrationTubeVolume[APPDATA.KEY.ProteinReference] === -1) {
        param.EnableButton = '';
        this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);
      } else this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);
    } else this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);

    this.forceUpdate();
  };

  saveNoTubeCapacitance = () => {
    const param = {
      EnableButton: 'DISABLE',
      currentStep: STEP_WIZARD.NoTubeCalibration,
    };

    this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);

    const tareStage = {
      Stage: TARE_STAGE_ENUM.Calibration,
    };

    PutRequest(APPDATA.API.DO_TARE, tareStage).then(this.successTareLoadCell);
  };

  successTareLoadCell = (response) => {
    const {dispatch} = this.props;

    const isTareSuccess = response.data;
    let successCount = 0;
    const tareStatusCheck = [];

    if (isTareSuccess[VOLUME_SENSOR_LABEL.Protein] === true) {
      tareStatusCheck.push(APPDATA.KEY.ProteinTube);
      successCount += 1;
    }

    if (isTareSuccess[VOLUME_SENSOR_LABEL.Buffer] === true) {
      tareStatusCheck.push(APPDATA.KEY.BufferTube);
      successCount += 1;
    }

    if (successCount === 2) {
      this._isTareDonePooling = this.poolingIsTareDone(tareStatusCheck);
    } else {
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.TARE_FAILED_TEXT,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    }
  };

  poolingIsTareDone = (tareStatusCheck) => {
    const tareDoneId = setInterval(() => {
      Get(APPDATA.API.TARE + APPDATA.API.IS_DONE, '', this.successGetisTareDone, tareStatusCheck);
    }, 300);

    return tareDoneId;
  };

  successGetisTareDone = (response, passingParam) => {
    const IstareDoneStatus = response.data;
    let totaltrue = 0;

    passingParam.forEach((value) => {
      if (IstareDoneStatus[value].IsDone === true) totaltrue += 1;
    });

    if (totaltrue === passingParam.length) {
      if (typeof this._isTareDonePooling !== 'undefined') clearInterval(this._isTareDonePooling);

      this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_COMPLATE, STEP_WIZARD.NoTubeCalibration);
    }
  };

  saveTubeCalibration = (parameter, step) => {
    const passParam = {parameter, step};
    const param = {
      EnableButton: 'DISABLE',
      currentStep: step,
    };
    this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, param);
    this.calibrateLoadCell(passParam);
  };

  getLoadCellVolumeSensor = (passParam) => {
    Get(APPDATA.API.GET_ALL_SENSOR_VALUE, '', this.setLoadCellVolumeSensor, passParam);
  };

  setLoadCellVolumeSensor = (response, passingVariabel) => {
    const {calibrationTubeVolume} = this.state;

    const {parameter, step} = passingVariabel;
    let BufferReference = parameter[APPDATA.KEY.BufferReference];
    let ProteinReference = parameter[APPDATA.KEY.ProteinReference];

    if (parameter[APPDATA.KEY.BufferReference] === -1) {
      BufferReference = calibrationTubeVolume.BufferReference;
    }

    if (parameter[APPDATA.KEY.ProteinReference] === -1) {
      ProteinReference = calibrationTubeVolume.ProteinReference;
    }

    const newCalibrationTubeVolume = calibrationTubeVolume;
    newCalibrationTubeVolume[APPDATA.KEY.ProteinReference] = ProteinReference;
    newCalibrationTubeVolume[APPDATA.KEY.BufferReference] = BufferReference;

    if (step === STEP_WIZARD.SampleTubeCalibration) {
      newCalibrationTubeVolume[APPDATA.KEY.ProteinSensor] = response.data.VolumeSensor.sensor0.toFixed(
        APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
      );
    }

    if (step === STEP_WIZARD.BufferTubeCalibration) {
      newCalibrationTubeVolume[APPDATA.KEY.BufferSensor] = response.data.VolumeSensor.sensor2.toFixed(
        APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
      );
    }

    this.setState({
      calibrationTubeVolume: newCalibrationTubeVolume,
    });

    if (step === STEP_WIZARD.BufferTubeCalibration) {
      this.setStateShowResult(newCalibrationTubeVolume);
    }
  };

  setStateShowResult = (calibrationTubeVolume) => {
    const resultPacket = [
      {
        id: CalibrationResultId.Protein.Reference,
        text: FieldLabel.ResultCalibration[0],
        result: calibrationTubeVolume[APPDATA.KEY.ProteinReference],
      },
      {
        id: CalibrationResultId.Protein.Sensor,
        text: FieldLabel.ResultCalibration[1],
        result: calibrationTubeVolume[APPDATA.KEY.ProteinSensor],
      },
      {
        id: CalibrationResultId.Buffer.Reference,
        text: FieldLabel.ResultCalibration[0],
        result: calibrationTubeVolume[APPDATA.KEY.BufferReference],
      },
      {
        id: CalibrationResultId.Buffer.Sensor,
        text: FieldLabel.ResultCalibration[1],
        result: calibrationTubeVolume[APPDATA.KEY.BufferSensor],
      },
    ];

    this.setState({
      resultPacket,
    });
  };

  submitCalibrationResult = () => {
    Put(APPDATA.API.SAVE_CALIBRATION, {}, () => consoleLog('successSaveCalibration'));
    Post(APPDATA.API.POST_SAVE_CONFIGURATION, {}, this.successSubmitCalibration);
  };

  successSubmitCalibration = (response) => {
    consoleLog('successSubmitCalibration', response);
    this.SuccessSaveCalibWizard();
  };

  setTopMenuSaveResult = (disabelSaveButton) => {
    const topButtonProperties = {
      id: APPDATA.FINISH,
      label: APPDATA.FINISH,
      onClick: this.submitCalibrationResult,
      disabled: disabelSaveButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.onClickBackButtonSave,
    };

    const titleMenuProperties = APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE;
    this.setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  TopMenuEvent = (param) => {
    this.setTopMenuProperties(param.topButtonProperties, param.backButtonProperties, param.titleMenuProperties);
  };

  setTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    const {dispatch} = this.props;

    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  // TODO : Create into 1 API
  calibrateLoadCell = (passingVariabel) => {
    const {calibrationTubeVolume} = this.state;
    const {parameter, step} = passingVariabel;

    let BufferReference = parameter[APPDATA.KEY.BufferReference];
    let ProteinReference = parameter[APPDATA.KEY.ProteinReference];

    if (parameter[APPDATA.KEY.BufferReference] === -1) {
      BufferReference = calibrationTubeVolume.BufferReference;
    }

    if (parameter[APPDATA.KEY.ProteinReference] === -1) {
      ProteinReference = calibrationTubeVolume.ProteinReference;
    }

    let type = [VOLUME_SENSOR_LABEL.Protein];
    const passParamSample = {parameter, step, type};
    type = [VOLUME_SENSOR_LABEL.Buffer];
    const passParamBuffer = {parameter, step, type};

    if (step === STEP_WIZARD.SampleTubeCalibration) {
      const bodyCalibrate = {
        [CalibrateParam.ReferenceWeight]: BufferReference,
        [CalibrateParam.SamplingNumber]: 10,
      };
      Put(
        APPDATA.API.CALIBRATE_LOAD_CELL + [VOLUME_SENSOR_LABEL.Protein],
        bodyCalibrate,
        this.successCalibrateLoadCell,
        passParamSample,
      );
    }

    if (step === STEP_WIZARD.BufferTubeCalibration) {
      const bodyCalibrate = {
        [CalibrateParam.ReferenceWeight]: ProteinReference,
        [CalibrateParam.SamplingNumber]: 10,
      };
      Put(
        APPDATA.API.CALIBRATE_LOAD_CELL + [VOLUME_SENSOR_LABEL.Buffer],
        bodyCalibrate,
        this.successCalibrateLoadCell,
        passParamBuffer,
      );
    }
  };

  successCalibrateLoadCell = (response, passingVariabel) => {
    const {dispatch} = this.props;
    const {type} = passingVariabel;
    consoleLog('successCalibrateLoadCell', {response, passingVariabel});

    if (response.data.Status === true) {
      if (type === VOLUME_SENSOR_LABEL.Protein || (isArray(type) && type[0] === VOLUME_SENSOR_LABEL.Protein))
        this._isCalibrateSampleDonePooling = this.poolingIsCalibrateDone(passingVariabel);

      if (type === VOLUME_SENSOR_LABEL.Buffer || (isArray(type) && type[0] === VOLUME_SENSOR_LABEL.Buffer))
        this._isCalibrateBufferDonePooling = this.poolingIsCalibrateDone(passingVariabel);
    } else {
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATE_FAILED_TEXT,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );

      if (type === VOLUME_SENSOR_LABEL.Protein || (isArray(type) && type[0] === VOLUME_SENSOR_LABEL.Protein))
        this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_COMPLATE, STEP_WIZARD.SampleTubeCalibration);

      if (type === VOLUME_SENSOR_LABEL.Buffer || (isArray(type) && type[0] === VOLUME_SENSOR_LABEL.Buffer))
        this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_COMPLATE, STEP_WIZARD.BufferTubeCalibration);
    }
  };

  poolingIsCalibrateDone = (passingVariabel) => {
    const {type} = passingVariabel;

    const calibrateDoneId = setInterval(() => {
      Get(
        APPDATA.API.CALIBRATE_LOAD_CELL + type + APPDATA.API.IS_DONE,
        {},
        this.successGetIsCalibrateDone,
        passingVariabel,
      );
    }, 300);

    return calibrateDoneId;
  };

  successGetIsCalibrateDone = (response, passingVariabel) => {
    const {type} = passingVariabel;

    consoleLog('successGetIsCalibrateDone', {response, passingVariabel});

    if (response.data.IsDone === true) {
      this.getLoadCellVolumeSensor(passingVariabel);

      if (type === VOLUME_SENSOR_LABEL.Protein || (isArray(type) && type[0] === VOLUME_SENSOR_LABEL.Protein)) {
        this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_COMPLATE, STEP_WIZARD.SampleTubeCalibration);

        if (typeof this._isCalibrateSampleDonePooling !== 'undefined')
          clearInterval(this._isCalibrateSampleDonePooling);
      }

      if (type === VOLUME_SENSOR_LABEL.Buffer || (isArray(type) && type[0] === VOLUME_SENSOR_LABEL.Buffer)) {
        this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU_COMPLATE, STEP_WIZARD.BufferTubeCalibration);

        if (typeof this._isCalibrateBufferDonePooling !== 'undefined')
          clearInterval(this._isCalibrateBufferDonePooling);
      }
    }
  };

  SuccessSaveCalibWizard = () => {
    const {dispatch, isRecalibration} = this.props;

    if (isRecalibration) {
      dispatch(setupActions.IsRecalibration(false));
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SUCCESS_UPDATE,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
        }),
      );
      backToHomePage();
    } else {
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SUCCESS_UPDATE,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
        }),
      );
      backToCalibrationPage();
    }
  };

  onClickBackButtonSave = () => {
    const {showCalibrationView} = this.state;

    if (showCalibrationView !== WizardView.wizardStep) return;

    this._bus.publish(Wizard.PubsubEvent.DIRECTION, Wizard.Direction.Previous);
    this.setState({
      backCalibration: true,
    });
  };

  wizardSteps = () => {
    const {isRecalibration} = this.props;
    const {calibrationTubeVolume, backCalibration, resultPacket} = this.state;

    return [
      {
        title: 'No Weight',
        activeTitle: 'No Weight',
        content: (
          <PoolingSamplingData
            params={ViewNoTubePoolingParam}
            calibrationStep={STEP_WIZARD.NoTubeCalibration}
            calibrationContent={APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.NO_TUBE_TEXT}
            backAction={this.ExitWizard}
            saveAction={this.saveNoTubeCapacitance}
            nextAction={this.nextOnClick}
            calibrationTubeVolume={calibrationTubeVolume}
            isRecalibration={isRecalibration}
          />
        ),
      },
      {
        title: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SAMPLE_SCALE,
        activeTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SAMPLE_SCALE,
        content: (
          <PoolingSamplingData
            params={ViewSampleTubePoolingParam}
            calibrationStep={STEP_WIZARD.SampleTubeCalibration}
            calibrationContent={APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SAMPLE_TUBE_TEXT}
            measures={APPDATA.FIELD_NAME.MEASURES}
            saveAction={this.saveTubeCalibration}
            backAction={this.onClickBackButtonSave}
            nextAction={this.nextOnClick}
            calibrationTubeVolume={calibrationTubeVolume}
          />
        ),
      },
      {
        title: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.BUFFER_SCALE,
        activeTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.BUFFER_SCALE,
        content: (
          <PoolingSamplingData
            params={ViewBufferTubePoolingParam}
            calibrationStep={STEP_WIZARD.BufferTubeCalibration}
            calibrationContent={APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.BUFFER_TUBE_TEXT}
            saveAction={this.saveTubeCalibration}
            backAction={this.onClickBackButtonSave}
            nextAction={this.nextOnClick}
            usingEmptyTubeCapacitanceFromProps={backCalibration}
            calibrationTubeVolume={calibrationTubeVolume}
          />
        ),
      },
      {
        title: 'Summary',
        activeTitle: 'Summary',
        content: (
          <ShowResult
            params={ViewFinishReferencePoolingParam}
            resultPacket={resultPacket}
            nextAction={this.nextOnClick}
          />
        ),
      },
    ];
  };

  render() {
    const {showCalibrationView} = this.state;

    return (
      <div className={showCalibrationView === WizardView.wizardStep ? '' : 'hidden'}>
        <Wizard
          step={this.wizardSteps()}
          nextActionCallback={this.nextActionCallbackWizard}
          backActionCallback={this.backActionCallbackWizard}
        />
      </div>
    );
  }
}
export default CalibrationLoadCellSensorWizard;
